import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import PanelBar from "../core/components/panelBar";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import React from "react";
export default class ResourcePlanningExpenses extends React.Component<any, {
    expenses: any;
}>{
    constructor(props) {
        super(props);
        this.state = {
            expenses: null
        }
    }

    private loadExpeses = async () => {
        if (!this.props.entity.ProjNr || !this.props.entity.PIndex)
            return;

        let result = await HTTPService.get<JsonResultClass<any>>("ResourcePlanningLookUp/GetSpesen?projNr="
            + encodeURIComponent(this.props.entity.ProjNr)
            + "&pIndex=" + encodeURIComponent(this.props.entity.PIndex));
        if (result.Code == 0) {
            this.setState({ expenses: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private getExpenses = () => {
        if (!this.state.expenses)
            return null;

        return <Expenses {...this.props} expenses={this.state.expenses} />
    }

    private getOvernightStay = () => {
        if (!this.state.expenses)
            return null;

        return <OvernightStay {...this.props} expenses={this.state.expenses} />
    }

    render() {
        return (
            <>
                <div style={{ marginTop: "7px" }} >
                    <PanelBar headerText={Helper.getTranslation("Field.Einsatz.ExpensesSelection")} iconName="search" onExpand={() => { this.loadExpeses() }} >
                        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                            <label style={{ marginTop: "5px", flexBasis: "100%" }}>{this.state.expenses?.Land}</label>
                            {this.props.type == "expenses" ? this.getExpenses() : this.getOvernightStay()}
                        </div>
                    </PanelBar>
                </div>
            </>
        );
    }
}

class Expenses extends React.Component<any, {
    value: any;
}>{
    private radioGroup: kendo.ui.RadioGroup;

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.entity.Spesen.toString()
        }
    }

    componentDidMount() {
        this.radioGroup = $("#expensesRadioGroup").kendoRadioGroup({
            items: [
                {
                    value: this.props.expenses["Spesen1"],
                    label: this.props.expenses["Spesen1"] + " (24 h)",
                    enabled: this.props.entity.RecordRight.CanWrite
                },
                {
                    value: this.props.expenses["Spesen2"],
                    label: this.props.expenses["Spesen2"] + " (14 h)",
                    enabled: this.props.entity.RecordRight.CanWrite
                },
                {
                    value: this.props.expenses["Spesen3"],
                    label: this.props.expenses["Spesen3"] + " (8 h)",
                    enabled: this.props.entity.RecordRight.CanWrite
                }
            ],
            value: this.state.value,
            change: (e) => {
                this.setState({ value: e.newValue }, () => {
                    General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, { command: "expensesChanged", value: this.state.value })
                });
            }
        }).data("kendoRadioGroup");
    }

    componentDidUpdate() {
        if (this.props.entity.Spesen != this.state.value && this.radioGroup)
            this.setState({ value: this.props.entity.Spesen }, () => {
                $("input[name='expensesRadioGroup']").prop("checked", false);
                this.radioGroup.value(this.state.value);
            });
    }

    render() {
        return <>
            <ul id="expensesRadioGroup"></ul>
        </>
    }
}


class OvernightStay extends React.Component<any, {
    value: any;
}>{
    private radioGroup: kendo.ui.RadioGroup;

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.entity.Uebernachtung.toString()
        }
    }

    componentDidMount() {
        this.radioGroup = $("#overnightStayRadioGroup").kendoRadioGroup({
            items: [
                {
                    value: this.props.expenses["Uebernachtung"],
                    label: this.props.expenses["Uebernachtung"] + ` (${Helper.getTranslation("Field.Enum.CapacityCalculationMode.Standard")})`,
                    enabled: this.props.entity.RecordRight.CanWrite
                }
            ],
            value: this.state.value,
            change: (e) => {
                this.setState({ value: e.newValue }, () => {
                    General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, { command: "overnightStayChanged", value: this.state.value })
                });
            }
        }).data("kendoRadioGroup");
    }

    componentDidUpdate() {
        if (this.props.entity.Uebernachtung != this.state.value)
            this.setState({ value: this.props.entity.Uebernachtung }, () => {
                $("input[name='overnightStayRadioGroup']").prop("checked", false);
                this.radioGroup.value(this.state.value);
            });
    }

    render() {
        return <>
            <ul id="overnightStayRadioGroup"></ul>
        </>
    }
}